import React from 'react';
import Hero from '../Hero';
import Spacing from '../Spacing';
import FunFact from '../FunFact';
import About from '../About';
import WhyChose from '../WhyChose';
import Service from '../Service';
import SectionHeading from '../SectionHeading';
import Cta from '../Cta';
import { pageTitle } from '../../helpers/PageTitle';
import { YOUTUBE_VIDEO_ID } from '../../constants'; 
// Fun fact data
const funfactData = [
  { title: 'FishBot Users', number: '200+' },
  { title: 'Tasks Automated', number: '3k+' },
  { title: 'Support ', number: '24/7' },
  { title: 'Years of Innovation', number: '1+' },
];

// Why choose feature data
const whyChoseFeatureData = [
  {
    title: 'Advanced AI-Powered Bot',
    content:
      'WarpSoft’s FishBot utilizes state-of-the-art AI for real-time detection and seamless automation, providing unmatched gaming efficiency.',
  },
  {
    title: 'User-Friendly Interface',
    content:
      'Designed with simplicity in mind, FishBot is perfect for gamers of all skill levels, offering intuitive controls and powerful capabilities.',
  },
  {
    title: '24/7 Dedicated Support',
    content:
      'Our team is always ready to assist you, ensuring a hassle-free experience from setup to ongoing usage.',
  },
];

// Service list data
const serviceListData = [
  {
    title: 'Bot Setup Assistance',
    subtitle: 'Get your FishBot up and running with expert guidance.',
    imgUrl: '/images/creative-agency/service_7.jpg',
  },
  {
    title: 'Real-Time Detection',
    subtitle:
      'Experience precise object detection with FishBot’s cutting-edge technology.',
    imgUrl: '/images/creative-agency/service_8.jpg',
  },
  {
    title: 'Customizable Features',
    subtitle:
      'Tailor FishBot to suit your unique gaming needs and preferences.',
    imgUrl: '/images/creative-agency/service_9.jpg',
  },
  {
    title: 'Regular Updates',
    subtitle:
      'Stay ahead with continuous improvements and new feature releases.',
    imgUrl: '/images/creative-agency/service_10.jpg',
  },
];

export default function Home() {
  // Set page title for SEO
  pageTitle('WarpSoft - Revolutionizing Gaming');

  // Google Ads conversion tracking function
  const gtagReportConversion = (url) => {
    var callback = function () {
      if (typeof(url) !== 'undefined') {
        window.location = url;
      }
    };
    window.gtag('event', 'conversion', {
      send_to: 'AW-16814718639/GuxcCMinrvwZEK_98NE-', // Conversion ID and Label
      value: 1.0, // Conversion value
      currency: 'TRY', // Currency
      event_category: 'engagement',
      event_label: 'Learn More Button',
      event_callback: callback,
    });
    return false;
  };

  return (
    <>
      {/* Hero Section */}
      <Hero
        title={[
          'Transform Your Gaming with FishBot',
          'AI-Powered Gaming Assistance',
          '24/7 Support Available',
        ]}
        subtitle="Experience precision and reliability with WarpSoft’s FishBot."
        videoSrc={`https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}`}
        bgUrl="/images/creative-agency/hero_video_bg_1.jpg"
      />
      <Spacing lg="125" md="70" />

      {/* Fun Facts */}
      <div className="container">
        <FunFact data={funfactData} />
      </div>
      <Spacing lg="125" md="70" />

      {/* About Section */}
      <About
        thumbnail="/images/creative-agency/about_1.png"
        uperTitle="Why Choose Us"
        title="The Future of Gaming Automation"
        subTitle="WarpSoft’s FishBot combines cutting-edge AI and seamless design to revolutionize your gaming experience."
        featureList={[
          'AI-powered efficiency',
          'Customizable for any need',
          '24/7 support from experts',
        ]}
        btnText="Learn More"
        onClick={() => gtagReportConversion('https://discord.gg/upbs5Unb5n')} // Google Ads conversion tracking on button click
      />
      <Spacing lg="185" md="75" />

      {/* Why Choose Section */}
      <WhyChose
        sectionTitle="Why Gamers Trust FishBot"
        sectionSubTitle="Our Advantages"
        whyChoseFeatureData={whyChoseFeatureData}
        thumbnailSrc="/images/creative-agency/why_choose_us_img_3.jpeg"
      />
      <Spacing lg="150" md="80" />

      {/* Our Services Section */}
      <section className="cs_primary_bg">
        <Spacing lg="143" md="75" />
        <div className="container">
          <SectionHeading
            title="Our Services"
            subTitle="What We Offer"
            variantColor="cs_white_color"
          />
          <Spacing lg="45" md="30" />
        </div>
        <div className="container">
          <Service
            sectionTitle="Our Services"
            sectionSubTitle="What We Offer"
            data={serviceListData}
          />
          <Spacing lg="135" md="65" />
        </div>
      </section>
    </>
  );
}
